import React from "react";
import styled from 'styled-components';

const Splitter = styled.div`
  display: block;
  width: 100%;
  height: 1px;
  border-top: 1px solid rgb(223, 225, 227);
  content: '';
  margin: 8px 0;
`;

export default Splitter;